'use client'
import { SubItemList } from '@/app/ui/parts/default/sp/itemlist/sub/itemlist'
import { queryType } from '@/lib/api/query'
import { getItems, itemType, paginationType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import Link from 'next/link'
import { useEffect, useState } from 'react'

type ItemListProps = {
  service: serviceType
  query: queryType
  slider: boolean
}

export const NewItemListClientComponent: React.FC<ItemListProps> = ({
  service,
  query,
  slider,
}) => {
  query.new = true
  const [itemData, setItemData] = useState<{
    items: itemType[]
    pagination: paginationType
  } | null>(null)
  useEffect(() => {
    const fetchData = async () => {
      const data = await getItems(service.service_id, query)
      setItemData(data)
    }
    fetchData().catch((error) => {
      console.error('Error fetching new items:', error)
    })
  }, [service.service_id, query])
  let href = `/new`
  if (query.category_id) {
    href = `/new?category_id=${query.category_id}`
  } else if (query.subcategory_id) {
    href = `/new?subcategory_id=${query.subcategory_id}`
  } else if (query.tag_id) {
    href = `/new?tag_id=${query.tag_id}`
  }
  if (!itemData) {
    return <div></div>
  }
  return (
    <div>
      <SubItemList items={itemData.items} service={service} slider={slider} />
      <div className="item-list-bottom text-center mt-4 mb-4">
        <Link href={href}>
          <button className="item-list-bottom-button bg-[#fafafa] relative py-3 px-8 text-sm rounded-lg border-[#dddddd] border">
            新着アイテムの一覧へ
            <span
              className="item-list-bottom-arrow absolute text-lg font-light"
              style={{ color: '#555353', top: '4px', right: '7px' }}
            >
              {' › '}
            </span>
          </button>
        </Link>
      </div>
    </div>
  )
}
